import { Box, Flex, Skeleton } from '@chaine/keychaine'
import React from 'react'

/**
 * Loading skeleton for performance metrics that mimics the structure of MetricsDisplay
 * Displays skeleton placeholders for section headings, dividers, subsection headings,
 * and metric rows with labels and values
 */
export const MetricsLoadingSkeleton: React.FC = () => (
  <Box>
    {/* Section 1: On-Time Performance */}
    <Box mb={6}>
      <Skeleton height="24px" width="200px" mb={3} />
      <Skeleton height="1px" width="100%" mb={2} />

      {/* Subsection: Recent Performance */}
      <Box mt={4}>
        <Skeleton height="18px" width="150px" mb={2} />
        {/* Metrics */}
        {[...Array(5)].map((_, i) => (
          <Flex key={`on-time-recent-${i}`} justify="space-between" py={1}>
            <Skeleton height="16px" width={`${Math.random() * 30 + 150}px`} />
            <Skeleton height="16px" width="50px" />
          </Flex>
        ))}
      </Box>

      {/* Subsection: Total Performance */}
      <Box mt={4}>
        <Skeleton height="18px" width="150px" mb={2} />
        {/* Metrics */}
        {[...Array(6)].map((_, i) => (
          <Flex key={`on-time-total-${i}`} justify="space-between" py={1}>
            <Skeleton height="16px" width={`${Math.random() * 30 + 150}px`} />
            <Skeleton height="16px" width="50px" />
          </Flex>
        ))}
      </Box>
    </Box>

    {/* Section 2: Tracking Performance */}
    <Box>
      <Skeleton height="24px" width="220px" mb={3} />
      <Skeleton height="1px" width="100%" mb={4} />

      {/* Subsection: Recent Performance */}
      <Box mt={4}>
        <Skeleton height="18px" width="150px" mb={2} />
        {/* Metrics */}
        {[...Array(2)].map((_, i) => (
          <Flex key={`tracking-recent-${i}`} justify="space-between" py={1}>
            <Skeleton height="16px" width={`${Math.random() * 30 + 150}px`} />
            <Skeleton height="16px" width="50px" />
          </Flex>
        ))}
      </Box>

      {/* Subsection: Total Performance */}
      <Box mt={4}>
        <Skeleton height="18px" width="150px" mb={2} />
        {/* Metrics */}
        {[...Array(2)].map((_, i) => (
          <Flex key={`tracking-total-${i}`} justify="space-between" py={1}>
            <Skeleton height="16px" width={`${Math.random() * 30 + 150}px`} />
            <Skeleton height="16px" width="50px" />
          </Flex>
        ))}
      </Box>

      {/* Subsection: Tracking Methods */}
      <Box mt={4}>
        <Skeleton height="18px" width="150px" mb={2} />
        {/* Metrics */}
        {[...Array(6)].map((_, i) => (
          <Flex key={`tracking-methods-${i}`} justify="space-between" py={1}>
            <Skeleton height="16px" width={`${Math.random() * 30 + 150}px`} />
            <Skeleton height="16px" width="50px" />
          </Flex>
        ))}
      </Box>
    </Box>
  </Box>
)
